import { useQuery } from "@tanstack/react-query";

import { fetchMailboxes } from "@/lib/mailboxesApi";

export const MAILBOXES_QUERY_KEY = ["mailboxes"] as const;

export function useMailboxesQuery() {
  return useQuery({
    queryKey: MAILBOXES_QUERY_KEY,
    queryFn: fetchMailboxes,
  });
}
